import Vue from 'vue';
import './layout.scss';
import layoutBase from '../layout-base.js';
import mhek from '../../modules/MHEK/mhek';
import '../../applications/news/news.js';
new Vue({ extends: layoutBase, components: { mhek } }).$mount('[data-layout-id="AHEL-app"]');
